document
  .querySelectorAll(".featured-collection__slider")
  .forEach((sliderElement) => {
    var swiper = new Swiper(sliderElement, {
      loop: false,
      speed: 300,
      slidesPerView: 1.5,
      spaceBetween: 20,
      navigation: {
        nextEl: ".featured-collection__slider .swiper-button-next",
        prevEl: ".featured-collection__slider .swiper-button-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          navigation: false,
        },
      },
    });
  });
